import React from 'react';
import { WingBlank, Flex, Button } from 'antd-mobile';
import { useUserStatus } from '../../../../../common/hooks/user-status';

const FormFooter = (props: any) => {
  const { isEdit, onSkip, onSubmit, meetid, type } = props;

  const { modelstatus } = useUserStatus(meetid);

  if (isEdit) {
    const currentModel = modelstatus[type];
    if (currentModel?.status === false) {
      return <div/>
    }
  }

  return (
    <WingBlank style={{ backgroundColor: '#fff', marginTop: 24, paddingBottom: 24 }}>
      <Flex justify='between'>
        {!isEdit && (
          <Button onClick={onSkip} type="ghost" size="large" style={{ width: '46%' }} inline>跳过</Button>
        )}
        <Button onClick={onSubmit} type="primary" size="large" style={{ width: isEdit ? '100%' : '46%' }} inline>填好了</Button>
      </Flex>
    </WingBlank>
  )
}

export default FormFooter;